// import { MDBBtn, MDBCard, MDBCardBody, MDBCol, MDBInput, MDBRow } from 'mdbreact';
import React from 'react';
import { Redirect } from 'react-router-dom';
// import vi_logo from '../../Assets/visaero_logo.png';
// import vd_logo from '../../Assets/visadone_logo.png';
// import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
// import axios from '../../authAxios'
// import { Input } from '@material-ui/core';
// import axios from 'axios'
// import TextField from '@material-ui/core/TextField';

// const brand_color = localStorage.getItem("brand_color")
export class RouteFromSite extends React.Component {
    constructor(props) {
        super(props)
    
        // console.log(">>>>> PROPS ORIGIN: "+this.props.match.params.origin)
        localStorage.setItem("site_origin",this.props.match.params.origin)
        localStorage.setItem("site_nationality",this.props.match.params.nationality)
        localStorage.setItem("site_travelling_to_identity",this.props.match.params.travelling_to_identity)
        localStorage.setItem("site_start_date",this.props.match.params.start_date)
        localStorage.setItem("site_end_date",this.props.match.params.end_date)
        localStorage.setItem("site_entry_type",this.props.match.params.entry_type)
        localStorage.setItem("site_visa_type",this.props.match.params.visa_type)
        localStorage.setItem("site_visa_id",this.props.match.params.visa_id)

        if(localStorage.getItem('session_id') == "" || localStorage.getItem('session_id') == null){
            window.location.href ="/login"
        }
    

        this.state = {
            
        }
        
    }

    componentDidMount(){
        const host = localStorage.getItem('host');

        
    }
    
    

    

    

    render(){
        if (this.state.isRegisteredUser){
            return  <Redirect to="/enter-password" /> 
        }
        if (this.state.isNewUser){
            return  <Redirect to="/verify-otp" /> 
        }
        return(
        
          "Redirecting"   
                
        );
    }
};

export default RouteFromSite;